<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9998 2.05005C6.51056 2.05005 2.05371 6.5069 2.05371 11.9962C2.05371 17.4865 6.51056 21.9433 11.9998 21.9433C17.4891 21.9433 21.946 17.4865 21.946 11.9962C21.946 6.5069 17.4891 2.05005 11.9998 2.05005ZM11.9998 3.63371C16.6148 3.63371 20.3623 7.38126 20.3623 11.9962C20.3623 16.6121 16.6148 20.3587 11.9998 20.3587C7.38492 20.3587 3.63738 16.6121 3.63738 11.9962C3.63738 7.38126 7.38492 3.63371 11.9998 3.63371ZM12.9633 16.348V10.5606C12.9633 9.85729 12.5971 9.49114 12.0038 9.49114C11.4026 9.49114 11.0364 9.85729 11.0364 10.5606V16.348C11.0364 17.0443 11.4026 17.4104 11.9959 17.4104C12.5971 17.4104 12.9633 17.0513 12.9633 16.348ZM10.9044 7.59335C10.9044 8.1796 11.3736 8.61177 11.9959 8.61177C12.6331 8.61177 13.0953 8.1796 13.0953 7.59335C13.0953 7.00811 12.6331 6.58293 11.9959 6.58293C11.3736 6.58293 10.9044 7.00811 10.9044 7.59335Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Info'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
